import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fa from 'vuetify/lib/locale/fa'

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    lang: {
        locales: {fa},
        current: 'fa',
    },
    theme: {
        themes: {
            light: {
                primary: "#22C0F1",
                secondary:'#5BD8FF',
                thirdColor:'#FFB703',
                greenColor:'#25D366',
            },
        },
    },
})
;
